import { render } from "./SubscriptionOverdue.vue?vue&type=template&id=29fbb243"
import script from "./SubscriptionOverdue.vue?vue&type=script&lang=js"
export * from "./SubscriptionOverdue.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__